export const sequenceWords = (arrayOfWords, separator = ', ') =>
  arrayOfWords.filter(w => w).join(separator);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/helpers/stringManipulations.js